import { SpinnerNamesEnum } from 'app/core/enums/ui/spinners';
import { ModalNamesEnum } from 'app/core/enums/ui/modals';
import {
  UIActions,
  UI_IDLE__SET_IDLE_TIMEOUT_STATUS,
  UI_SPINNERS__SET_SPINNER_VISIBLE,
  UI_SPINNERS__SET_ASYNC_SPINNER_VISIBLE,
  UI_MODALS__SET_MODAL_VISIBLE,
  UI_SPINNERS__SET_PAYMENT_SPINNER_VISIBLE,
  UI_ANNOUNCE__VISIBLE,
  UI_IS_CALENDAR_OPEN,
  UI_IS_MOBILE_NAV_OPEN
} from './types';

/**
 * @description [Idle] 設置閒置逾時狀態 (Action)
 * @param isTimeout 逾時
 */
export const setIdleTimeoutStatusAction = (isTimeout: boolean): UIActions => ({
  type: UI_IDLE__SET_IDLE_TIMEOUT_STATUS,
  payload: { isTimeout }
});

/**
 * @description [Spinners] 設置 Spinner 能見度 (Action)
 * @param name Spinner name
 * @param visible 能見度
 */
export const setSpinnerVisibleAction = (name: SpinnerNamesEnum, visible: boolean): UIActions => ({
  type: UI_SPINNERS__SET_SPINNER_VISIBLE,
  payload: { name, visible }
});

/**
 * @description [Spinners] 設置 Async Spinner 能見度 (Action)
 * @param isRequest 是否為請求 (Request) 動作
 */
export const setAsyncSpinnerVisibleAction = (isRequest: boolean): UIActions => ({
  type: UI_SPINNERS__SET_ASYNC_SPINNER_VISIBLE,
  payload: { isRequest }
});

/**
 * @description [Spinners] 設置 Async Spinner 能見度 (Action)
 * @param visible
 */
export const setPaymentSpinnerVisibleAction = (visible: boolean): UIActions => ({
  type: UI_SPINNERS__SET_PAYMENT_SPINNER_VISIBLE,
  payload: { visible }
});

/**
 * @description [Modals] 設置 Modal 能見度 (Action)
 * @param name Modal name
 * @param visible 能見度
 */
export const setModalVisibleAction = (name: ModalNamesEnum, visible: boolean): UIActions => ({
  type: UI_MODALS__SET_MODAL_VISIBLE,
  payload: { name, visible }
});

/**
 * @description [Announce] 設置 Announce 能見度 (Action)
 * @param visible 能見度
 */
export const setAnnounceVisibleAction = (visible: boolean): UIActions => ({
  type: UI_ANNOUNCE__VISIBLE,
  payload: { visible }
});

/**
 * @description [isCalendarOpen] 設置 isCalendarOpen (Action)
 * @param isCalendarOpen 是否打開小日曆
 */
export const setIsCalendarOpenAction = (isCalendarOpen: boolean): UIActions => ({
  type: UI_IS_CALENDAR_OPEN,
  payload: { isCalendarOpen }
});

/**
 * @description [isMobileNavOpen] 設置 isMobileNavOpen (Action)
 * @param isMobileNavOpen 是否打開側邊選單
 */
export const setIsMobileNavOpenAction = (isMobileNavOpen: boolean): UIActions => ({
  type: UI_IS_MOBILE_NAV_OPEN,
  payload: { isMobileNavOpen }
});
